module.exports = __webpack_public_path__ + "img/drug-12.d2d54a9e.png";